import React from 'react';
import { Routes, Route } from 'react-router-dom';

import About from './About/About';
import Home from './Home/Home';
import Picks from './Picks/Picks';
import PickDetail from './Picks/PickDetail';
import OurBet from './OurBet/OurBet';
import PickInsights from './PickInsights/PickInsights';
import TodaysPick from './TodaysPick/TodaysPick';
import Account from './Account/Account';
import Contact from './Contact/Contact';
import Pricing from './Pricing/Pricing';

type RouterComponentProps = {
  childrenMap: { [key: string]: JSX.Element };
};

function Router({ childrenMap }: RouterComponentProps) {
  return (
    <Routes>
      <Route path={'/'} element={<Home children={childrenMap['home']} />} />
      <Route path={'/home'} element={<Home children={childrenMap['home']} />} />
      <Route path={'/about'} element={<About children={childrenMap['about']} />} />
      <Route
        path={'/picks/:pickId'}
        element={<PickDetail children={childrenMap['pickDetail']} />}
      />
      <Route path={'/picks'} element={<Picks children={childrenMap['picks']} />} />
      <Route path={'/our-bet'} element={<OurBet children={childrenMap['ourBet']} />} />
      <Route path={'/insights'} element={<PickInsights children={childrenMap['pickInsights']} />} />
      <Route path={'/todays-lock'} element={<TodaysPick children={childrenMap['todaysPick']} />} />
      <Route path={'/account'} element={<Account children={childrenMap['account']} />} />
      <Route path={'/contact'} element={<Contact children={childrenMap['contact']} />} />
      <Route path={'/pricing'} element={<Pricing children={childrenMap['pricing']} />} />
    </Routes>
  );
}

export default Router;
